// Lightweight analytics client. Fires POST /api/analytics/track for pageviews and product clicks.
// Anonymous session ID is persisted in localStorage so we can count uniques without an account.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = 'dw_analytics_session';
const REFERRER_KEY = 'dw_analytics_first_referrer';
const UTM_KEY = 'dw_analytics_utm';

function ensureSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = 'sess_' + Math.random().toString(36).slice(2) + '_' + Date.now();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function firstReferrer() {
  // Sticky: remember the ORIGINAL referrer & UTM for this browser (attribution)
  let ref = localStorage.getItem(REFERRER_KEY);
  if (ref === null) {
    ref = document.referrer || '';
    localStorage.setItem(REFERRER_KEY, ref);
  }
  return ref;
}

function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const hasNew = fields.some((f) => params.get(f));
  if (hasNew) {
    const utm = {};
    fields.forEach((f) => (utm[f] = params.get(f) || null));
    localStorage.setItem(UTM_KEY, JSON.stringify(utm));
    return utm;
  }
  try {
    return JSON.parse(localStorage.getItem(UTM_KEY) || '{}');
  } catch {
    return {};
  }
}

async function post(payload) {
  try {
    await axios.post(`${API}/analytics/track`, payload, { withCredentials: true });
  } catch {
    // never break the app because analytics failed
  }
}

export function trackPageview(path) {
  const utm = captureUtm();
  post({
    event_type: 'pageview',
    path: path || window.location.pathname + window.location.search,
    referrer: firstReferrer(),
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
    session_id: ensureSessionId(),
  });
}

export function trackProductClick(productId, metadata = {}) {
  const utm = captureUtm();
  post({
    event_type: 'product_click',
    path: window.location.pathname + window.location.search,
    referrer: firstReferrer(),
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
    product_id: productId,
    session_id: ensureSessionId(),
    metadata,
  });
}

export function trackEvent(event_type, metadata = {}) {
  const utm = captureUtm();
  post({
    event_type,
    path: window.location.pathname + window.location.search,
    referrer: firstReferrer(),
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
    session_id: ensureSessionId(),
    metadata,
  });
}
